<template lang="html">
  <v-layout @click="showMap = !showMap">
    <v-layout column class="event">
      <chat-user-header main-icon="my_location"
                        :event="event"
                        :participants="participants">
        checked in near {{event.vicinity}} at {{event.timestamp | formatDate}}
      </chat-user-header>
      <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center @click.stop.prevent>
        <load-map v-if="showMap"
            width="100%"
            height="250px"
            :load="load"
            :position-markers="checkinEvents"
            :origin-place-id="originPlaceId"
            :destination-place-id="destinationPlaceId">
        </load-map>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm2 v-if="showTime"
            class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
      <span>{{event.timestamp | formatDate}}</span>
    </v-flex>

    <div class="media-event pr-2">
      <v-icon v-if="!showMap">map</v-icon>
      <v-icon v-if="showMap">
        minimize
      </v-icon>
    </div>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import LoadMap from '@/components/LoadMap';
import checkinEventsUtils from '@/mixins/checkinEventsUtils';
import ChatUserHeader from './ChatUserHeader';

export default {
  name: 'UserCheckinEvent',
  mixins: [checkinEventsUtils],
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    load: {
      type: Object,
      required: false,
    },
    events: {
      type: Array,
      required: false,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    LoadMap,
    ChatUserHeader,
  },
  data() {
    return {
      showMap: false,
      mapZoomLevel: 4,
      mapOptions: {
        zoomControl: false,
        gestureHandling: 'none',
      },
    };
  },
  computed: {
    originPlaceId() {
      return _.get(this.load, 'tacticalInfo.loadDetails.pickupLocation.googlePlace.placeId', null);
    },
    destinationPlaceId() {
      return _.get(this.load, 'tacticalInfo.loadDetails.dropoffLocation.googlePlace.placeId', null);
    },
    checkinEvents() {
      return this.formatCheckinEvents(this.events, this.participants);
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #D1D100 solid;
  }
  .media-event {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/UserCheckinEvent.vue